export default __webpack_public_path__ + "static/media/v-card.1f072af2.png";